/** Shared by the team create, team detail and add-on assign-teams toggles. */
export const DENY_PORTAINER_ACCESS_TOOLTIP =
  'Members of this team will not be able to see or use Portainer. They will be redirected to their add-on on login.';
